import { History, Clock, Activity } from 'lucide-react';

export const HistoryModal = () => {
  // Mock analytics data for display purposes
  const mockAnalytics = [
    {
      id: '1',
      action: 'session_validation_success',
      timestamp: new Date().toISOString(),
      data: { type: 'api', data_freshness: 'api_fresh' }
    },
    {
      id: '2',
      action: 'app_state_updated',
      timestamp: new Date(Date.now() - 300000).toISOString(),
      data: { authenticated: true }
    },
    {
      id: '3',
      action: 'modal_opened',
      timestamp: new Date(Date.now() - 600000).toISOString(),
      data: { modal: 'history' }
    }
  ];

  return (
    <div className="p-6 space-y-6">
      {/* History Header */}
      <div className="card p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
            <History className="w-6 h-6 text-brand" />
            <h3 className="text-xl font-semibold text-th-primary">
              Activity History
            </h3>
          </div>
        </div>
        <p className="text-th-secondary">
          Recent session and app activities (live data not stored locally).
        </p>
      </div>

      {/* Activity Timeline */}
      <div className="card p-6">
        <h4 className="text-lg font-semibold text-th-primary mb-4 flex items-center space-x-2">
          <Activity className="w-5 h-5 text-accent" />
          <span>Recent Activity</span>
        </h4>

        <div className="space-y-3 max-h-96 overflow-y-auto">
          {mockAnalytics.map((event, _) => (
            <div key={event.id} className="flex items-start space-x-3 p-3 bg-surface rounded-xl">
              <div className="w-2 h-2 bg-brand rounded-full mt-2"></div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <p className="text-th-primary font-medium">
                    {event.action.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase())}
                  </p>
                  <div className="flex items-center space-x-1 text-th-secondary text-xs">
                    <Clock className="w-3 h-3" />
                    <span>
                      {new Date(event.timestamp).toLocaleString()}
                    </span>
                  </div>
                </div>
                {event.data && Object.keys(event.data).length > 0 && (
                  <pre className="text-th-secondary text-xs mt-1 bg-surface p-2 rounded overflow-x-auto">
                    {JSON.stringify(event.data, null, 2)}
                  </pre>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Summary Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-elevated border border-subtle rounded-xl p-4">
          <h5 className="text-th-secondary text-sm mb-1">Total Events</h5>
          <p className="text-2xl font-bold text-brand">
            {mockAnalytics.length}
          </p>
        </div>
        <div className="bg-elevated border border-subtle rounded-xl p-4">
          <h5 className="text-th-secondary text-sm mb-1">Today</h5>
          <p className="text-2xl font-bold text-accent">
            1
          </p>
        </div>
        <div className="bg-elevated border border-subtle rounded-xl p-4">
          <h5 className="text-th-secondary text-sm mb-1">This Week</h5>
          <p className="text-2xl font-bold text-status-warning">
            3
          </p>
        </div>
      </div>
    </div>
  );
};
